<template>
    <div class="min-h-20 relative bg-white rounded-2xl py-4 px-4 grid shadow-md w-full overflow-hidden">
        <div class="flex items-center gap-x-4 w-full">
            <div class="min-w-14">
                <Icon v-if="kpiType?.icon_url" class="w-14 h-14" :src="kpiType?.icon_url"></Icon>
            </div>
            <div class="w-full" :class="{ 'pr-5': kpiType?.help_widget_item }">
                <div class="flex space-x-6">
                    <span class="text-xl font-semibold leading-snug tracking-tighter truncate pr-1">
                        {{ kpiValue }}
                    </span>
                </div>
                <div class="max-w-full">
                    <span class="text-gray-600 leading-tight text-lg max-w-full" v-html="kpiText"></span>
                </div>
            </div>
        </div>
        <HelpWidgetButton v-if="kpiType?.help_widget_item" :item="kpiType.help_widget_item" class="absolute bottom-0.5 right-0.5" />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import sanitizeHtml from 'sanitize-html';
import { Kpi, KpiType } from '@/types';
import { store } from '@/plugins/store';
import HelpWidgetButton from '@/components/common/helpWidget/HelpWidgetButton.vue';

export default defineComponent({
    components: {
        HelpWidgetButton,
    },
    props: {
        kpi: {
            type: Object as () => Kpi,
            required: true,
        },
    },
    computed: {
        kpiType(): KpiType | undefined {
            return store.state.kpiTypes.find((kpiType) => kpiType.id === this.kpi.type_id);
        },
        kpiValue(): string {
            if (this.kpi.value === null) {
                return '-';
            }
            let value = this.kpiType?.prefix ? `${this.kpiType?.prefix} ` : '';
            value += typeof this.kpi.value === 'number' ? this.$n(this.kpi.value) : this.kpi.value;
            value += this.kpiType?.suffix ? ` ${this.kpiType?.suffix}` : '';
            return value;
        },
        kpiText(): string {
            return sanitizeHtml(this.kpiType?.text_wrapped?.replaceAll('##', '&shy;') || this.kpiType?.text || '');
        },
    },
});
</script>
